import { ClipboardList } from "lucide-react";
import {
  CharterParamsSchema,
  defaultCharterParams,
  type CharterParams,
} from "@playbookai/widget-schemas";
import { registerWidget } from "../registry.js";
import type { SqlWidgetDef } from "../types.js";
import { CharterWidget } from "./Component.js";

/**
 * Register-only in Wave 1: generic APIs may create an unbound, creator-owned
 * charter, but only VSM-owned routes may attach it to a VSM in Wave 3.
 */
export const charterDef: SqlWidgetDef<CharterParams> = {
  kind: "charter",
  label: "VSM Charter",
  modes: [],
  singleton: true,
  defaultSize: { w: 620, h: 360 },
  defaultParams: defaultCharterParams,
  Component: CharterWidget,
  storage: "sql",
  schema: CharterParamsSchema,
  accent: "purple",
  icon: ClipboardList,
  subtitle: "Problem, scope, goals, and takt calendar",
  defaultRoster: false,
  category: "single",
  layout: { col: "full", row: 1, width: 620, height: 360 },
};

registerWidget(charterDef);
